import autobind from "autobind-decorator";
import { observable, runInAction, toJS } from "mobx";
import { asyncAction } from "mobx-utils";
import { UserService } from "services";

@autobind
class UsersStore {
  modalStore;

  constructor(stores) {
    this.modalStore = stores.modalStore;
  }

  @observable
  code = 200;

  @observable
  message = "";

  @observable
  data = {
    background_image_path: null,
    certify: {
      is_phone_certify: null,
      is_ipin_certify: null,
    },
    email: "",
    info_point: 0,
    is_email_certify: false,
    login_ip: {},
    is_second_password: false,
    item: {
      change_background_image: 0,
      change_nick: 0,
      change_profile_image: 0,
      change_today_word: 0,
    },
    level: "",
    nick: "",
    password_change_date: "",
    profile_image_path: null,
    today_word: null,
    id: null,
    is_admin: false,
  };

  @asyncAction
  *getInfo() {
    const res = yield UserService.getInfo();

    if (res.code === 200) {
      runInAction(() => {
        this.code = res.code;
        this.resultDataUpdate(res.data);
      });
    } else {
      runInAction(() => {
        this.code = res.code;
        this.message = res.message;
      });
    }

    return res.code === 200;
  }

  @asyncAction
  *getCheckMe() {
    const res = yield UserService.getInfo();

    if (res.code === 200) {
      runInAction(() => {
        this.code = res.code;
        this.resultDataUpdate(res.data);
      });
    } else {
      runInAction(() => {
        this.code = res.code;
        this.message = res.message;
      });
    }
  }

  @asyncAction
  *actionUserFind(param, callback) {
    const { nick } = param;

    if (!param) {
      return;
    }
    if (!nick) {
      this.modalStore.openAlertModal({
        message: "조회 하실 닉네임을 입력하세요",
      });
      return;
    }

    const res = yield UserService.userFind(nick);

    if (res.code === 200) {
      runInAction(() => {
        this.code = res.code;
      });

      callback && callback(res);
    } else {
      this.modalStore.openAlertModal({
        message: res.message,
      });

      runInAction(() => {
        this.code = res.code;
        this.message = res.message;
      });
    }
  }

  resultDataUpdate(data) {
    runInAction(() => {
      this.data.background_image_path = !!data.background_image_path
        ? data.background_image_path
        : null;
      this.data.certify = !!data.certify ? data.certify : this.data.certify;
      this.data.email = !!data.email ? data.email : "";
      this.data.info_point = !!data.info_point ? data.info_point : 0;
      this.data.is_email_certify = !!data.is_email_certify
        ? data.is_email_certify
        : false;
      this.data.login_ip = !!data.login_ip ? data.login_ip : {};
      this.data.is_second_password = !!data.is_second_password
        ? data.is_second_password
        : false;
      this.data.item.change_background_image = !!data.item
        .change_background_image
        ? data.item.change_background_image
        : 0;
      this.data.item.change_nick = !!data.item.change_nick
        ? data.item.change_nick
        : 0;
      this.data.item.change_profile_image = !!data.item.change_profile_image
        ? data.item.change_profile_image
        : 0;
      this.data.item.change_today_word = !!data.item.change_today_word
        ? data.item.change_today_word
        : 0;
      this.data.level = !!data.level ? data.level : "";
      this.data.nick = !!data.nick ? data.nick : "";
      this.data.password_change_date = !!data.password_change_date
        ? data.password_change_date
        : "";
      this.data.profile_image_path = !!data.profile_image_path
        ? data.profile_image_path
        : null;
      this.data.today_word = !!data.today_word ? data.today_word : null;
      this.data.id = !!data.mb_id ? data.mb_id : null;
      this.data.is_admin = data.is_admin;
    });
  }
}

export default UsersStore;
